import { Container, Row, Col } from "react-bootstrap";
import OrgChartImages from "../component/OrgChartImage";
import { useEffect } from "react";
import BoardOfDirectorsData from "../static/BoardOfDirectorsData"
import HeroBanner from "../component/HeroBanner";
import getImageLogosSrcSet from "../helper/ImageKit";

const BoardOfDirectors = () => {
  useEffect(()=>{
    document.title = "JCI Lucena - Board of Directors"
  }, [])

  return (
    <div>
      <div className="hero-banner-div">
        <HeroBanner
          className="about-us-hero-banner"
          src={'https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-1200,f-auto,q-80 1920w'}
          srcSet={`
            https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-400,fo-top,q-60 400w,
            https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-800,fo-top,q-60 800w,
            https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-1200,fo-top,q-60 1200w,
            https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-1920,fo-top,q-70 1920w,
            https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-2560,fo-top,q-80 2560w,
            https://ik.imagekit.io/wwg4nuz3a/bod/rock-on.jpg?tr=w-3840,fo-top,q-80 3840w
          `}
          // src={'post-placeholder.png'}
          sizes="100vw"
        />
      </div>
      <Container>
        <Row>
          <Col>
            <h1 className="org-chart-header"><b>Board of Directors</b></h1>
            <div className="org-chart-div">
              {/* {BoardOfDirectorsData.map((board) => (
                // might need to remove .slice .reverse and just reverse the order of the generated array
                <OrgChartImages
                  className="org-chart-image"
                  key={board.id}
                  src={board.src}
                  name={board.name}
                  text={board.text}
                />
              ))} */}
              {BoardOfDirectorsData.map((boardMember) => {
                const img = getImageLogosSrcSet(boardMember.src);
                return (
                  <OrgChartImages
                    key={img.id}
                    src={img.src}
                    srcSet={img.srcSet}
                    sizes={img.sizes}
                    text={boardMember.text}
                    name={boardMember.name}
                    alt="Sponsor logo"
                    className="org-chart-image"
                  />
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default BoardOfDirectors;